<template>
  <div class="column is-four-fifth customer">
    <h4 class="title is-4">Kunduppgifter</h4>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Namn</label>
          <div class="control has-icons-left">
            <input
              name="given-name"
              class="input"
              type="text"
              v-model="customer.first_name"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Efternamn</label>
          <div class="control">
            <input
              name="family-name"
              class="input"
              type="text"
              v-model="customer.last_name"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="field" v-if="extendedFields">
      <label class="label">Personnummer</label>
      <div class="control">
        <input name="tel" class="input" type="text" v-model="customer.ssi" />
      </div>
    </div>

    <div class="field">
      <label class="label">Adress</label>
      <div class="control has-icons-left">
        <input
          name="street-address"
          class="input"
          type="text"
          v-model="customer.thoroughfare"
        />
        <span class="icon is-small is-left">
          <i class="fas fa-home"></i>
        </span>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Postnummer</label>
          <div class="control">
            <input
              name="postal-code"
              class="input"
              type="text"
              v-model="customer.postal_code"
            />
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Stad</label>
          <div class="control">
            <input
              name="address-level2"
              class="input"
              type="text"
              v-model="customer.locality"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="extendedFields">
      <div class="column">
        <div class="field">
          <label class="label">Namn förälder 1</label>
          <div class="control has-icons-left">
            <input
              name="parent-name-first"
              class="input"
              type="text"
              v-model="customer.parent_name_first"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Namn förälder 2</label>
          <div class="control has-icons-left">
            <input
              name="parnet-name-second"
              class="input"
              type="text"
              v-model="customer.parent_name_second"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="extendedFields">
      <div class="column">
        <div class="field">
          <label class="label">Telefonnummer förälder 1</label>
          <div class="control has-icons-left">
            <input
              name="parent-phone-first"
              class="input"
              type="text"
              v-model="customer.parent_phone_first"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-phone"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Telefonnummer förälder 2</label>
          <div class="control has-icons-left">
            <input
              name="parnet-phone-second"
              class="input"
              type="text"
              v-model="customer.parent_phone_second"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-phone"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label">Mailadress</label>
      <div class="control has-icons-left">
        <input
          name="email"
          class="input"
          type="text"
          v-model="customer.email"
        />
        <span class="icon is-small is-left">
          <i class="fas fa-envelope"></i>
        </span>
      </div>
    </div>

    <div class="field" v-if="!extendedFields">
      <label class="label">Telefonnummer</label>
      <div class="control has-icons-left">
        <input
          name="tel"
          class="input"
          type="text"
          v-model="customer.phone_number"
        />
        <span class="icon is-small is-left">
          <i class="fas fa-phone"></i>
        </span>
      </div>
    </div>

    <div class="field" v-if="extendedFields">
      <label class="label">Annat</label>
      <div class="control">
        <input name="tel" class="input" type="text" v-model="customer.other" />
      </div>
    </div>

    <br />
    <div class="field" v-if="extendedFields">
      <label class="checkbox">
        Är medlem: <input type="checkbox" v-model="customer.member" />
      </label>
    </div>
    <div class="field" v-if="extendedFields">
      <label class="checkbox">
        Får förekomma på bilder:
        <input type="checkbox" v-model="customer.photo" />
      </label>
    </div>

    <div class="buttons">
      <a class="button is-primary" @click="updateCustomer"> Uppdatera Kund </a>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "CustomerSettings",
  components: {},
  props: {
    customer: Object,
  },
  data: function () {
    return {
      extendedFields: false,
    };
  },
  methods: {
    updateCustomer() {
      axios.put("/api/customers/" + this.customer._id + "/", this.customer);
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
  },
  created() {
    this.getExtendedFields();
  },
  watch: {
    customer: function () {
      this.fetchCourses();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.customer {
  text-align: left;
}

.info {
  text-align: left;
}

.input {
  max-width: 30em;
}
</style>